import { useEffect, useCallback } from 'react';

/**
 * Generic modal component with ESC key support and backdrop click to close.
 * Uses DaisyUI modal classes.
 */
export default function Modal({ open, onClose, title, size = 'lg', children }) {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
  }, [onClose]);

  useEffect(() => {
    if (open) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [open, handleKeyDown]);

  if (!open) return null;

  const sizeClass = {
    sm: 'max-w-lg',
    md: 'max-w-2xl',
    lg: 'max-w-5xl w-11/12',
    full: 'max-w-7xl w-11/12',
  }[size] || 'max-w-5xl w-11/12';

  return (
    <dialog className="modal modal-open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className={`modal-box ${sizeClass} p-0 overflow-hidden`}>
        {title && (
          <div className="flex items-center justify-between px-4 py-2 bg-base-200 border-b border-base-300">
            <h3 className="font-bold text-lg">{title}</h3>
            <button className="btn btn-sm btn-ghost" onClick={onClose}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>
        )}
        {children}
      </div>
    </dialog>
  );
}
